var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('order-card'),(_vm.isEditPage)?[_c('order-items')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }